module.exports = __webpack_public_path__ + "static/media/entry_group_notification.d3ac6161.svg";